'use client';

import { createContext } from 'react';
import type {
  Brands,
  ThemeDensity,
  Themes,
  ThemeSizing,
} from '@frameio/vapor-theme';
import type {
  AccentNeutralBrand,
  CustomAccentNeutralColors,
  CustomBrand,
} from './types';

type CoreThemeProviderValues = {
  themeName?: Themes;
  brandName?: Brands;
  customBrand?: CustomBrand;
  accentNeutralColors?: CustomAccentNeutralColors;
  accentNeutralBrand?: AccentNeutralBrand;
  density?: ThemeDensity;
  sizing?: ThemeSizing;
};

export type ThemeProviderContextValue = CoreThemeProviderValues & {
  outermostThemeProviderValues?: CoreThemeProviderValues;
};

export const ThemeProviderContext = createContext<ThemeProviderContextValue>(
  {}
);
